// extracted by mini-css-extract-plugin
module.exports = {"Emoji":"baz_a bha_i bha_q bha_j"};